// extracted by mini-css-extract-plugin
export default {"autoProlongation":"AutomaticPerminuteTariff_autoProlongation__yrGjG","helper":"AutomaticPerminuteTariff_helper__DNomc"};